import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { orderActions } from '@store/order/orderSlice';
import { getTempOrder } from '@utils/restoreOrderUtils';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

declare module '@stackflow/config' {
    interface Register {
        EasyCardIdentifySuccessActivity: { token: string; }
    }
}

const EasyCardIdentifySuccessActivity: ActivityComponentType<'EasyCardIdentifySuccessActivity'> = ({ params }) => {
    const { token } = params;
    const { push, replace } = useFlow();
    const dispatch = useDispatch();
    const handleIdentifySuccess = async () => {
        replace('MainActivity', {}, { animate: false });
        // 주문을 통해 들어왔다면 주문 복구
        const tempOrder = await getTempOrder('EASY_CARD');
        if (tempOrder) {
            dispatch(orderActions.copy(tempOrder));
            push('OrderActivity', {}, { animate: false });
        } else {
            push('EasyCardActivity', {}, { animate: false });
        }
        // 본인인증 토큰으로 PIN을 재설정한다
        push('EasyCardPinActivity', { pinResetToken: token });
    };
    useEffect(() => {
        handleIdentifySuccess();
    }, []);
    return (
        <AppScreen>
            <Loading/>
        </AppScreen>
    );
};

export default EasyCardIdentifySuccessActivity;
